import actions from 'od-modules/secure_store/actions';
import {dispatch} from 'od-modules/secure_store/store';
import trackingUtils from 'od-modules/utils/tracking.utils';

const DEFAULT_RISKY_CREDIT_CARD = false;
const TRACKING_CATEGORY = 'flights_pay_page';
const TRACKING_RISKY_LABEL = 'ccard_risky_inline_error_time';
const TRACKING_ELIGIBLE_LABEL = 'ccard_eligible_prime_risky_time';

export default Backbone.Model.extend({
    silentChange: false,
    connect: true,
    selectors: ['pricing', 'primeMemberSelected'],
    dataURL: 'isCreditCardAvailableForSubscription',
    defaults: {
        creditCardBinNumber: null,
        isRiskyCard: false,
        ccard_risky_inline_error_time: 0,
        isPreviousCreditCardRisky: false,
    },

    initialize() {
        this.listenTo(this, 'change:creditCardBinNumber', this.onCreditCardBinNumberChange);
        dispatch({type: actions.SET_RISKY_CREDIT_CARD, entry: DEFAULT_RISKY_CREDIT_CARD});
    },

    url() {
        return Odigeo.Settings.getProperty('serviceCollectionMethodFormatter')(`${this.dataURL}/${this.get('creditCardBinNumber')}`);
    },

    onCreditCardBinNumberChange() {
        const {isSubscriptionAdded} = this.get('primeMemberSelected');
        let isRiskyCreditCard = false;
        this.fetch({
            success: (model, isSuitable) => {
                isRiskyCreditCard = !isSuitable;
                const isConditionToDisplayMessage = isSubscriptionAdded || isRiskyCreditCard;

                isConditionToDisplayMessage && this.setPreviousCreditCardRisky(isRiskyCreditCard);
                dispatch({type: actions.SET_MEMBERSHIP_CHURN_RISK, entry: {isRiskyCreditCard}});
                this.setRiskyCard(isConditionToDisplayMessage && isRiskyCreditCard);
            },
            error: () => this.setRiskyCard(false),
        });
    },

    setPreviousCreditCardRisky(value) {
        this.set({isPreviousCreditCardRisky: value});
    },

    setRiskyCard(value) {
        this.setRiskyCountAndTrack(value);
        this.set({isRiskyCard: value});
        dispatch({type: actions.SET_RISKY_CREDIT_CARD, entry: value});
        if (!value) {
            Odigeo.trigger('block-risky-cards:evaluateYearlySubscription', this.get('creditCardBinNumber'));
        }
    },

    setRiskyCountAndTrack(value) {
        let count = this.get(TRACKING_RISKY_LABEL);

        if (value) {
            this.set(TRACKING_RISKY_LABEL, ++count);
            this.track('payment_details_error', TRACKING_RISKY_LABEL);
        } else {
            count !== 0 && this.track('payment_details_msg', TRACKING_ELIGIBLE_LABEL);
        }
    },

    track(action, label) {
        const count = this.get(TRACKING_RISKY_LABEL);
        trackingUtils.trackEventWithCategory(TRACKING_CATEGORY, action, `${label}:${count}`);
    },
});
